import { render, staticRenderFns } from "./main-notice.vue?vue&type=template&id=2b26778b&scoped=true&"
import script from "./main-notice.vue?vue&type=script&lang=js&"
export * from "./main-notice.vue?vue&type=script&lang=js&"
import style0 from "./main-notice.vue?vue&type=style&index=0&id=2b26778b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b26778b",
  null
  
)

export default component.exports